export const isMobile = (testString = navigator.userAgent) =>
  /Mobi|Android|iPhone|iPad|iPod|Mobile/i.test(testString)
